import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type AssignNotifiedPartyMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.AssignNotifiedPartyInput;
}>;

export type AssignNotifiedPartyMutationResult = { __typename?: 'Mutation' } & {
  bookingAssignNotifiedParty?: GraphQLTypes.Maybe<
    { __typename?: 'AssignNotifiedPartyPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const AssignNotifiedPartyDocument = gql`
  mutation assignNotifiedParty($input: AssignNotifiedPartyInput!) {
    bookingAssignNotifiedParty(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
